import { useEffect, useState } from 'react'

import { DEFAULT_LANGUAGE } from '@src/config/localisation/locale-config.constants'
import type { TAbsoluteLocale } from '@src/config/localisation/locale-config.types'
import { useStatsigDynamicLocaleConfig } from '@src/experiments/statsig-integration/use-statsig-dynamic-locale-config.hook'
import { getSessionStorage } from '@src/utils/enhancedSessionStorage'
import { getNonce } from '@src/utils/nonce.utils'

import isBrowser from '../utils/isBrowser'
declare global {
  interface Window {
    Klarna?: {
      OnsiteMessaging?: {
        refresh: () => void
      }
    }
  }
}
const KLARNA_SESSION_STORAGE_KEY = '__klarna_sdk_default-config'
const isScriptLoadedInBody = () => !!document.querySelector('#klarnaOSM')
const useKlarnaModule = (instalmentSalePrice: number, _locale: TAbsoluteLocale = DEFAULT_LANGUAGE) => {
  const localeConfig = useStatsigDynamicLocaleConfig()
  const clientId = localeConfig?.klarnaClientId
  const [isScriptLoaded, setIsScriptLoaded] = useState(isBrowser() && isScriptLoadedInBody())
  useEffect(() => {
    if (isScriptLoaded || !clientId) return
    const script = document.createElement('script')
    const nonce = getNonce()
    script.setAttribute('data-environment', 'production')
    script.setAttribute('async', 'true')
    script.setAttribute('data-client-id', clientId)
    script.setAttribute('id', 'klarnaOSM')
    if (nonce) {
      script.setAttribute('nonce', nonce)
    }
    getSessionStorage().removeItem(KLARNA_SESSION_STORAGE_KEY)
    script.src = 'https://js.klarna.com/web-sdk/v1/klarna.js'
    document.body.appendChild(script)
    setIsScriptLoaded(true)
  }, [clientId, isScriptLoaded])
  useEffect(() => {
    if (!isScriptLoaded) return
    isBrowser() && window.Klarna?.OnsiteMessaging?.refresh()
  }, [instalmentSalePrice, isScriptLoaded])
  return isScriptLoaded
}
export default useKlarnaModule
